import useAjax from "@hooks/use-ajax.hook";
import { useCallback } from "react";

const useDeleteReservation = () => {
  const { request, error, loading, clearError } = useAjax();

  const deleteReservation = useCallback(
    (id: number | string) =>
      request<{ status: "success" }>("delete_reservation", {
        id,
      }),
    [request]
  );

  return { deleteReservation, loading, error, clearError };
};

export default useDeleteReservation;
